import React, { useState } from "react";
import { Field } from "react-final-form";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";

const PasswordField: React.FC = () => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="flex flex-col gap-1.5">
            <label
                htmlFor="login-password"
                className="ml-1 font-nunito text-xs font-black uppercase leading-4 tracking-wide text-gray-900"
            >
                Mot de passe
            </label>
            <div className="relative">
                <Field name="password">
                    {({ input, meta }) => (
                        <>
                            <Input
                                {...input}
                                id="login-password"
                                type={showPassword ? "text" : "password"}
                                placeholder="********"
                                autoComplete="current-password"
                                required
                                className="h-16 rounded-3xl border-0 bg-slate-50 px-8 pr-14 font-nunito text-base font-bold text-gray-900 outline outline-1 outline-slate-100 focus-visible:outline-2 focus-visible:outline-indigo-600 focus-visible:ring-0 focus-visible:ring-offset-0"
                            />
                            {meta.submitError && (
                                <div aria-live="polite" className="ml-1 mt-1 text-xs text-red-500">{meta.submitError}</div>
                            )}
                        </>
                    )}
                </Field>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    onClick={() => setShowPassword((visible) => !visible)}
                    className="absolute right-5 top-1/2 -translate-y-1/2 text-slate-600 hover:bg-transparent hover:text-gray-900 focus-visible:ring-indigo-600"
                    aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                    {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
                </Button>
            </div>
        </div>
    );
};

export default PasswordField;
